import React, { Component } from 'react'
import TextWithFieldname from '../texts/TextWithFieldname';
import ResultError from '../results/ResultError';
import IconRender from '../std/IconRender';

class WaitSetting extends Component {

	handleStop() {
		this.props.onStopWaiting();
	}
	handleResetUnauthorised() {
		this.props.onResetUnauthorised();
	}
	render() {
		let mainResponse = null;
		switch (this.props.settings.process) {
			case 'vehiclesConfig':
			case 'vehiclesStock':
			case 'vehiclesDefault':
				mainResponse = this.props.responseSimulation.vehiclesRental;
				break;
			case 'options':
				mainResponse = this.props.responseSimulation.optionsRental;
				break;
			case 'accessories':
				mainResponse = this.props.responseSimulation.accessoriesIncrease;
				break;
			case 'basket':
			case 'summary':
			default:
				mainResponse = this.props.responseSimulation.vehicleDetails;
				break;
		}
		return (
			<div>
				{(this.props.posts.isFetchingSimulation
					|| this.props.posts.isFetchingSimulationOption || this.props.posts.isFetchingSimulationAccessories || this.props.posts.isFetchingSimulationVehicles)
					&& <div className="row border round">
						<div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
							<span className="visually-hidden">Loading...</span>
						</div>
						<button className="btn btn-light" onClick={() => this.handleStop()} >
							<IconRender name="x-circle" />
						</button>
					</div>
				}
				{this.props.env.resultStatus && this.props.env.resultStatus.resHttpStatus !== 200 && this.props.env.resultStatus.resHttpStatus !== 0
					&& <div className="row border round">
						{this.props.settings.process !== 'vehiclesConfig' && this.props.vehicle.presentation
							&& this.props.settings.process !== 'vehiclesStock' && this.props.settings.process !== 'vehiclesDefault'
							&& <div>
								{this.props.vehicle.presentation.logo && this.props.vehicle.presentation.logo.trim() !== '' &&
									<img src={this.props.vehicle.presentation.logo} height="45" alt={this.props.vehicle.presentation.longLabel} />
								}
								<h6>{this.props.vehicle.presentation.longLabel}</h6>
							</div>
						}
						<div className='text-danger'>
							{this.props.env.resultStatus.resHttpStatus && <TextWithFieldname fieldname="HttpStatus" developperView={this.props.settings.isDevelopperView} variant="h6">
								http request failed: {this.props.env.resultStatus.resHttpStatus} - {this.props.env.resultStatus.statusText}
							</TextWithFieldname>}
							{this.props.env.resultStatus.error && this.props.env.resultStatus.error.message
								&& <TextWithFieldname fieldname="HttpStatus"
									developperView={this.props.settings.isDevelopperView} variant="h6">
									Error: {this.props.env.resultStatus.error.message}
								</TextWithFieldname>}
						</div>
						<button className="btn btn-light" onClick={() => this.handleResetUnauthorised()} >
							<IconRender name="x-circle" />
						</button>
					</div>
				}
				<ResultError
					responseObject={mainResponse}
					settings={this.props.settings}
					vehicle={this.props.vehicle}
				/>
			</div>
		)
	}

}


export default (WaitSetting)

